import { isArray, toInteger } from "lodash";
import React, { useCallback, useState, useMemo, createRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { converteHorarioRodada } from "src/loteria/utils/extracaoUtils";
import { convertDate, convertIntegerToMoney } from "src/modules/helpers";
import { addAposta, enviarAposta } from "src/reducers/carrinho/carrinhoActions";
import { selectConcursosDate } from "src/reducers/concurso/concursoActions";
import { Ticket } from "src/rifa/components";
import { hasLogin, hasPixParam, hasPreTicketParam, hasWalletParam, savePreTicket } from "../../utils/getPreTickets";
import Moment from "moment";

import "src/styles/supertime.scss";
import Carrinho from "src/newDesign/components/carrinho";
import DateSelector from "src/newDesign/components/date-selector";
import ValorInput from "src/newDesign/components/valor-input";
import { forceInt } from "../../utils/forceInt";

function SuperTime({ selectedContest, topRef, toggleErrorModal }) {
  const dispatch = useDispatch();
  const objUser = useSelector((state) => state.usuario.objUser);
  const datasConcursoSel = useSelector(
    (state) => state.concurso.datasConcursoSel
  );
  const arrApostas = useSelector((state) => state.carrinho.arrApostas);

  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState([]);
  const [valor, setValor] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);

  const [ticketBilhetes, setTicketBilhetes] = useState([]);

  const [cart, setCart] = useState([]);
  const isPreTicketParam = hasPreTicketParam();
  const isPixParam = hasPixParam();
  const isWalletParam = hasWalletParam();
  const isLogin = hasLogin();

  const [currentPreTicketCode, setCurrentPreTicketCode] = useState();
  const [currentPixTicket, setCurrentPixTicket] = useState();
  const [isPreTicket, setIsPreTicket] = useState(false);
  const [showETicket, setShowEticket] = useState(false);

  const carrinhoRef = createRef(null);

  const handleClickLeague = (serie) => {
    if (
      selectedLeague.some(
        (l) => l.objTipoJogo.vchNome === serie.objTipoJogo.vchNome
      )
    ) {
      setSelectedLeague((state) =>
        state.filter((l) => l.objTipoJogo.vchNome !== serie.objTipoJogo.vchNome)
      );
    } else {
      setSelectedLeague((state) => state.concat([serie]));
    }
  };

  const handleClickTeam = (team) => {
    if (selectedTeams.some((t) => t.sntNumero === team.sntNumero)) {
      setSelectedTeams((state) =>
        state.filter((t) => t.sntNumero !== team.sntNumero)
      );
    } else {
      setSelectedTeams((state) => state.concat([team]));
    }
  };

  const handleRemoveCart = (apostaId) => {
    const newCart = cart
      .filter((item) => item.Aposta_ID !== apostaId)
      .map((item, index) => ({ ...item, Aposta_ID: index + 1 }));

    setCart(newCart);

    const newArrApostas = arrApostas
      .filter((item) => item.Aposta_ID !== apostaId)
      .map((item, index) => ({
        ...item,
        Aposta_ID:
          item.Aposta_ID > apostaId ? item.Aposta_ID - 1 : item.Aposta_ID,
      }));

    dispatch(addAposta(newArrApostas));

    const totalGeral = newValorTotal(
      datasConcursoSel,
      valorTotal,
      newArrApostas
    );

    if (totalGeral !== undefined) {
      setValorTotal(totalGeral);
    }
  };

  const handleAddCart = () => {
    if (selectedLeague.length <= 0 && selectedTeams.length <= 0) {
      toggleErrorModal("Aposta Inválida", "Nenhum time ou liga selecionados.");
      return;
    }

    if (valor / 100 < selectedContest.objTipoJogo.numValorMinimoAposta) {
      toggleErrorModal("Aposta Inválida", "Valor da Aposta inválida.");
      return;
    }

    if (valor / 100 > selectedContest.lstTamanhoFixo[0].numValorMaximoAposta) {
      toggleErrorModal("Aposta Inválida",
      "Valor da Aposta maior que R$ " +
      selectedContest.lstTamanhoFixo[0].numValorMaximoAposta);

      return;
    }

    const formatedLeague = selectedLeague.map((league) => ({
      ...league,
      isLeague: true,
      bitMegaBola: false,
      nome: league.objTipoJogo.vchNome,
      numeros: 0,
      valorMegaBola: 0,
      numValor: valor,
      numValorTotal: valorTotal,
      sntTipoJogo: league.objTipoJogo.sntTipoJogo,
      vchNumero: 0,
      vchPremio: 1,
      valor,
      Aposta_ID: cart.length + 1,
    }));

    const formatedTeam = selectedTeams.map((team) => ({
      ...team,
      objTipoJogo: selectedContest.objTipoJogo,
      isLeague: false,
      numValor: valor,
      numValorTotal: valorTotal,
      sntTipoJogo: 8888,
      vchNumero: team.sntNumero,
      vchPremio: 1,
      nome: team.vchNome,
      bitMegaBola: false,
      numeros: team.sntNumero,
      valorMegaBola: 0,
      valor,
      Aposta_ID: cart.length + 1,
    }));

    const aposta = {
      Aposta_ID: cart.length + 1,
      teams: formatedTeam,
      league: formatedLeague,
      subtotal: formatedTeam
        .concat(formatedLeague)
        .reduce((sum, item) => sum + item.valor, 0),
    };

    setCart((state) => state.concat([aposta]));

    const newArrApostas = arrApostas.concat(
      formatedLeague.concat(formatedTeam)
    );

    dispatch(addAposta(newArrApostas));

    setSelectedLeague([]);
    setSelectedTeams([]);

    const totalGeral = newValorTotal(
      datasConcursoSel,
      valorTotal,
      newArrApostas
    );

    if (totalGeral !== undefined) {
      setValorTotal(totalGeral);
    }
    if (carrinhoRef.current) {
      carrinhoRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const newValorTotal = (datasConcurso, currentValorTotal, arrApostas) => {
    if (arrApostas != undefined && arrApostas.length > 0) {
      var qtdConcursos = datasConcurso.length;
      return (
        arrApostas.reduce((sum, aposta) => {
          return sum + aposta.valor;
        }, 0) * qtdConcursos
      );
    } else if (arrApostas.length === 0) {
      return 0;
    } else {
      return undefined;
    }
  };

  const handleChkDatasChange = (datasConcurso) => {
    const totalGeral = newValorTotal(datasConcurso, valorTotal, arrApostas);

    dispatch(selectConcursosDate(datasConcurso));

    if (totalGeral !== undefined) {
      setValorTotal(totalGeral);
    }
  };

  const getArrExtracaoData = () => {
    const arrData = [];

    const concursoDiario = objUser.objConcursos.arrConcursos;
    const concursoRodada = objUser.objConcursos.arrConcursosGame;

    const concurso = concursoRodada
      .concat(concursoDiario)
      .filter((e) => e.sntTipojogo === selectedContest.objTipoJogo.sntTipoJogo);

    for (let i = 0; i < datasConcursoSel.length; i++) {
      const data = {
        tnyExtracao: concurso[0].tnyExtracao,
        sntConcurso: concurso[0].sntConcurso,
        intNumeroSorteio: concurso[0].intNumeroConcurso,
        sdtData: "",
        ConcursoData_ID: 0,
        vcHorarioSorteio: "",
      };

      if (
        concurso[0].arrConcursoSorteio &&
        concurso[0].arrConcursoSorteio.length > 0 &&
        concurso[0].arrConcursoSorteio[0].intHorarioRodada > 0
      ) {
        const concursoData_ID = toInteger(datasConcursoSel[i]);

        data.ConcursoData_ID = concursoData_ID;
        data.sdtData = concurso[0].sdtData;

        const intHorarioRodada = concurso[0].arrConcursoSorteio.filter(
          (c) => c.ConcursoData_ID === concursoData_ID
        )[0].intHorarioRodada;

        data.vcHorarioSorteio = converteHorarioRodada(intHorarioRodada);
      } else {
        data.sdtData = datasConcursoSel[i];
      }

      arrData.push(data);
    }

    return { arrData, concurso };
  };

  const getArrAposta = () => {
    const arrAposta = [];

    let numValorTotal = 0;
    for (let i = 0; i < arrApostas.length; i++) {
      const apostaCorrente = arrApostas[i];

      numValorTotal += apostaCorrente.valor;

      const aposta = {
        sntTipoJogo: apostaCorrente.sntTipoJogo,
        vchNumero: isArray(apostaCorrente.numeros)
          ? apostaCorrente.numeros.join("")
          : apostaCorrente.numeros === 0
          ? "00"
          : apostaCorrente.numeros.toString().padStart(2, "0"),
        vchPremio: selectedContest.lstPremioFixo[0].vchPremioFixo,
        numValor: apostaCorrente.valor / 100,
        numValorTotal: apostaCorrente.valor / 100,
      };

      arrAposta.push(aposta);
    }

    return { arrAposta, numValorTotal };
  };

  const getCarrinho = () => {
    return arrApostas.map((aposta, index) => {
      return {
        type: "super-time",
        isLeague: aposta.isLeague,
        Aposta_ID: index + 1,
        valor: aposta.valor,
        numeros: [aposta.numeros === 0 ? "00" : `${aposta.numeros}`],
        tipo: aposta.objTipoJogo,
        vchURLImagem: aposta.vchURLImagem,
        nome: aposta.nome,
      };
    });
  };

  const handleTransaction = (isPreTicket = false, isPix = false) => {
    setIsPreTicket(isPreTicket);

    if (datasConcursoSel.length < 1) {
      toggleErrorModal("Aposta Inválida", "Favor selecionar ao menos uma data de concurso.");
      return;
    }

    // const arrApostas2 = arrApostas;

    const arrExtracaoData = getArrExtracaoData();

    const transaction = {
      intNumeroConcurso: arrExtracaoData.concurso[0].sntConcurso,
      Cliente_ID: objUser.Cliente_ID,
      Site_ID: forceInt(objUser.Site_ID),
      CID: objUser.CID,
      chrSerial: objUser.ChrSerial,
      Session_ID: objUser.Session_ID,
      chrCodigoPonto: objUser.ChrCodigoPonto,
      chrCodigoOperador: objUser.ChrCodigoOperador,
      strToken: objUser.TokenLE,
      sdtDataHora: new Date(),
      bitConcurso: selectedContest.objTipoJogo.bitConcurso,
      arrExtracaoData: arrExtracaoData.arrData,
      arrApostas: getArrAposta().arrAposta,
      numValorApostas: getArrAposta().numValorTotal / 100,
      Carrinho: getCarrinho(),
      sntQuantidadeApostas: getArrAposta().arrAposta.length,
      valorTotal: getArrAposta().numValorTotal,
    };

    dispatch(enviarAposta(transaction, transactionSuccess, isPreTicket, isPix, (title,message)=>{
      toggleErrorModal(title, message);
      setCart([]);
      dispatch(addAposta([]));
  }));
  };

  const transactionSuccess = (ETicket, isPreTicket, isPix) => {
    dispatch(addAposta([]));

    setSelectedLeague([]);
    setSelectedTeams([]);
    setCart([]);

    if (!ETicket) {
      return;
    }

    if (isPreTicket) {
      setCurrentPreTicketCode(ETicket.vchPreTicket);
      return;
    }

    /**
     * Visto que a estrutura dos dados Para a a geração do card de bilhete não são Uniformes
     * a longo da aplicação, se torna necessário mapear para uma estrutura aceita pelo componente
     */
    const getPossivelRetorno = (length) => {
      return selectedContest.lstTamanhoFixo.filter(
        (e) => e.tnyTamanho === length * 2
      )[0].numValorPagoTamanhoFixo;
    };

    const leagues = ETicket.detail.Carrinho.filter((ap) => ap.isLeague).map(
      (ap) => ({
        type: ap.type,
        arrNumeros: ap.numeros,
        valor: ap.valor,
        nome: ap.tipo.vchNome,
        possivelRetorno: ap.tipo.numValorPagoJogo,
        vchURLImagem: ap.vchURLImagem,
      })
    );

    const teams = ETicket.detail.Carrinho.filter((ap) => !ap.isLeague).map(
      (ap) => ({
        type: ap.type,
        arrNumeros: ap.numeros,
        valor: ap.valor,
        nome: ap.nome || ap.tipo.vchNome,
        possivelRetorno: getPossivelRetorno(ap.numeros.length),
        vchURLImagem: ap.vchURLImagem,
      })
    );

    const itens = (teams || []).concat(leagues || []);

    const prize =
      (itens.reduce(
        (sum, item) =>
          sum > item.possivelRetorno ? sum : item.possivelRetorno,
        0
      ) *
        itens[0].valor) /
      100;

    const arrBilhetes = ETicket.detail.arrExtracaoData.map((ap, i) => {
      return {
        bets: undefined,
        value: ETicket.detail.numValorApostas,
        date: ETicket.detail.sdtDataHora.toLocaleString(),
        prize: prize,
        extraction: undefined,
        concurso: `${convertDate(ap.sdtData)} ${
          ap.vcHorarioSorteio.length > 0 ? ap.vcHorarioSorteio : ""
        }`,
        venda: ETicket.arrETicket[i],
        name: selectedContest.objTipoJogo.vchNome.toUpperCase(),
        image: undefined,
        leagues,
        teams,
        isLoteria: !ETicket.detail.bitConcurso,
        intNumeroPule: isPreTicket ? null : ETicket.arrIntNumeroPule[i],
        vchCodigoSeguranca: isPreTicket ? null : ETicket.arrCodigoSeguranca[i],
        chrSerial: objUser.ChrSerial,
        maxDate: `${Moment(ap.sdtData).format("DD/MM/YYYY")}`,
      };
    });
    if (isPix) {      
      setCurrentPixTicket({
        bilhetes: arrBilhetes,
        timestamp: Date.now(),
        objTipoJogo: selectedContest.objTipoJogo,
        ...ETicket
      })
    } else {
      setTicketBilhetes(arrBilhetes);
      setCurrentPixTicket(null);
      if(isPreTicket) savePreTicket({bilhetes: arrBilhetes, preTicket: ETicket.vchPreTicket});
    }
  };

  const SuperTimeContent = useCallback(
    ({ serie }) => {
      return (
        <div className="supertime-content">
          <button
            onClick={() => handleClickLeague(serie)}
            className={`supertime-button-league ${
              selectedLeague.some(
                (l) => l.objTipoJogo.vchNome === serie.objTipoJogo.vchNome
              )
                ? "active"
                : ""
            }`}
          >
            {!!serie.vchURLImagem && <img src={serie.vchURLImagem} />}
            <p>{serie.objTipoJogo.vchNome}</p>
            <p>
              (Paga {serie.objTipoJogo.numValorPagoJogo}x o valor da aposta)
            </p>
          </button>
          <div className="supertime-grid">
            {serie.lstItemApuracao.map((team) => (
              <button
                onClick={() => handleClickTeam(team)}
                className={`supertime-button-team ${
                  selectedTeams.some((t) => t.sntNumero === team.sntNumero)
                    ? "active"
                    : ""
                }`}
              >
                {!!team.vchURLImagem && <img src={team.vchURLImagem} />}
                <p>
                  {team.vchNome.replace(/\s/g, "").substr(0, 3).toUpperCase()}{" "}
                  {team.sntNumero && team.sntNumero.toString().padStart(2, "0")}
                </p>
              </button>
            ))}
          </div>
        </div>
      );
    },
    [selectedLeague, selectedTeams, selectedContest]
  );

  const europaInfo = useMemo(() => {
    return selectedContest.supertimeList.find((serie) =>
      serie.objTipoJogo.vchNome.includes("Europa")
    );
  }, [selectedContest]);

  const renderPixTicket = (ETicket) => {
    return <PixTicket ticket={ETicket} onClose={() => setShowEticket(false)} toggleErrorModal={toggleErrorModal}/>;
  }

  return (
    <React.Fragment>
      <section className="section-container">
        <h2>1. Escolha um time e/ou liga</h2>
        <div className="supertime-container">
          {selectedContest.supertimeList
            .filter((serie) => serie.objTipoJogo.vchNome.includes("Serie"))
            .map((serie) => (
              <SuperTimeContent serie={serie} />
            ))}
        </div>
        <div className="supertime-container">
          {europaInfo && (
            <button
              onClick={() => handleClickLeague(europaInfo)}
              className={`supertime-button-league ${
                selectedLeague.some(
                  (l) =>
                    l.objTipoJogo.vchNome === europaInfo.objTipoJogo.vchNome
                )
                  ? "active"
                  : ""
              }`}
            >
              {!!europaInfo.vchURLImagem && (
                <img src={europaInfo.vchURLImagem} />
              )}
              <p>{europaInfo.objTipoJogo.vchNome}</p>
              <p>
                (Paga {europaInfo.objTipoJogo.numValorPagoJogo}x o valor da
                aposta)
              </p>
            </button>
          )}

          {selectedContest.supertimeList
            .filter(
              (serie) =>
                !serie.objTipoJogo.vchNome.includes("Serie") &&
                !serie.objTipoJogo.vchNome.includes("Europa")
            )
            .map((serie) => (
              <SuperTimeContent serie={serie} />
            ))}
        </div>
      </section>

      <section className="section-container">
        <div>
          <ValorInput
            onChange={(value) => setValor(value)}
            title="2. Valor"
            minValue={selectedContest.objTipoJogo.numValorMinimoAposta}
          />
        </div>

        <button onClick={() => handleAddCart()} className="btn submit-button">
          Adicionar ao Carrinho
        </button>
      </section>

      <section className="section-container" ref={carrinhoRef}>
        <Carrinho
          arrSupertime={cart}
          title={selectedContest.objTipoJogo.vchNome.toLowerCase()}
          apagaAposta={(apostaId) => handleRemoveCart(apostaId)}
        />
      </section>
      <section className="section-container">
        <DateSelector
          selectedContest={selectedContest}
          handleChange={(datasConcurso) => handleChkDatasChange(datasConcurso)}
        />

        {valorTotal > 0 && isWalletParam &&
          <button
            onClick={() => handleTransaction(false, false)}
            className="btn bg-primary submit-button"
          >
            + Finalizar{valorTotal > 0 && ` - R$ ${convertIntegerToMoney(valorTotal)}`}
          </button>
        }
        {(valorTotal > 0 && isPixParam && isLogin) &&
          <button
            type="button"
            className={`btn btn-primary pull-right submit-button`}
            onClick={() => handleTransaction(false, true)}
          >
            Pagar Agora!{valorTotal > 0 && ` - R$ ${convertIntegerToMoney(valorTotal)}`}
          </button>
        }
        {isPreTicketParam && (
          <button
            type="button"
            className={`btn btn-primary pull-right submit-button`}
            onClick={() => handleTransaction(true, false)}
          >
            Gerar pre-ticket
          </button>
        )}
      </section>

      {ticketBilhetes && ticketBilhetes.length > 0 && (
        <Ticket bilhetes={ticketBilhetes}
        onClose={() => setTicketBilhetes([])}
        preTicket={currentPreTicketCode?currentPreTicketCode:false}/>
      )}
      {currentPixTicket && showETicket &&
        renderPixTicket(currentPixTicket)
      }
    </React.Fragment>
  );
}

export default SuperTime;



// WEBPACK FOOTER //
// ./src/newDesign/pages/super-time.jsx